// This program has been developed by students from the bachelor Computer Science at
// Utrecht University within the Software Project course.
// © Copyright Utrecht University (Department of Information and Computing Sciences)
const default_colors = ['#636EFA', '#EF553B', '#00CC96', '#AB63FA', '#FFA15A', '#19D3F3', '#FF6692', '#B6E880', '#FF97FF', '#FECB52']

export const pie_colors = default_colors

export const bar_color = default_colors

export const histogram_color = default_colors

export const line_color = default_colors

export const boxplot_colors = default_colors